<template>
  <el-dialog
    v-if="session"
    id="sessionAttendance"
    :title="`${$t('coach.leader.attendance.title')}
      ${leader.full_name ? leader.full_name : $t('coach.leader.attendance.theLeader')}`"
    :visible.sync="showLocal"
    :width="dialogWidth"
  >
    <div class="notice">
      <div
        v-if="session.status === 'pending'"
        class="ongoing"
      >
        <div class="content defaultCursor">
          {{ $t('coach.leader.attendance.isCompleted') }}
        </div>

        <el-radio-group
          v-model="checkAttendance"
          @change="nextActionReason = ''"
        >
          <el-radio :label="true">
            {{ $t('common.yes') }}
          </el-radio>
          <el-radio :label="false">
            {{ $t('common.no') }}
          </el-radio>
        </el-radio-group>

        <div
          v-if="checkAttendance === false"
          class="nextAction"
        >
          <div class="content">
            {{ $t('coach.leader.attendance.nextAction') }}:
          </div>

          <el-radio-group
            v-model="nextAction"
            class="nextActionRadio"
            @change="nextActionReason = ''"
          >
            <el-radio :label="'reschedule'">
              {{ $t('coach.leader.attendance.doReschedule') }}
            </el-radio>
            <el-radio :label="'cancel'">
              {{ $t('coach.leader.attendance.doCancel') }}
            </el-radio>
          </el-radio-group>

          <el-input
            v-if="nextAction"
            v-model="nextActionReason"
            type="textarea"
            :autosize="{minRows: 2, maxRows: 4}"
            :placeholder="$t('coach.leader.attendance.placeholderReason')"
          />
        </div>
      </div>

      <div v-else-if="session.status === 'completed'">
        {{ $t('coach.leader.attendance.status.completed') }}
      </div>

      <div v-else-if="session.status === 'confirmed'">
        {{ $t('coach.leader.attendance.status.confirmed') }}
      </div>

      <div v-else-if="!session.status">
        {{ $t('coach.leader.attendance.status.unreached') }}
      </div>
    </div>

    <span
      slot="footer"
      class="dialog-footer"
    >
      <el-button
        type="secondary"
        round
        @click="showLocal = false"
      >
        {{ $t('common.cancel') }}
      </el-button>
      <el-button
        v-if="session.status === 'pending'"
        v-loading="loading"
        type="primary"
        :disabled="!canSubmit"
        round
        @click="submit"
      >
        <span>
          {{ $t('common.submit') }}
        </span>
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import api from '@/api';
import dialog from '@/mixins/dialog';

export default {
  name: 'AttendanceModal',
  mixins: [dialog],

  props: {
    leader: {
      type: Object,
      default: null,
    },

    session: {
      type: Object,
      default: null,
    },
  },

  data: () => ({
    checkAttendance: null,
    nextAction: null,
    nextActionReason: '',
    loading: false,
  }),

  computed: {
    canSubmit() {
      if (this.checkAttendance) return true;

      if (this.checkAttendance === false) {
        if (this.nextActionReason) {
          return true;
        }
      }

      return false;
    },
  },

  methods: {
    async submit() {
      try {
        this.loading = true;
        if (this.checkAttendance) {
          await api.leaderDoesAttendance(this.session.uuid);
        } else {
          const data = {
            action: this.nextAction === 'reschedule'
              ? 'no_meeting_reschedule' : 'no_meeting_cancel',
            reason: this.nextActionReason,
          };
          await api.leaderDoesNotAttendance(this.session.uuid, data);
        }
        this.$message.success(this.$t('coach.leader.attendance.confirmed'));
        this.sendEventBus();
      } catch (err) {
        if (err.msg) {
          this.$message.error(err.msg);
        }
        console.log(err);
      } finally {
        this.loading = false;
        this.showLocal = false;
      }
    },

    sendEventBus() {
      // For vuex state
      this.$EventBus.$emit('alert_changed', { type: 'Attendance', uuid: this.session.uuid });
    },
  },
};
</script>

<style lang="scss" scoped>
  #sessionAttendance {
    text-align: left;

    .el-dialog {
      max-width: 550px;
    }

    .notice {
      margin-bottom: 10px;
      word-break: break-word;

      div {
        font-size: 16px;
        color: #303133;
      }

      .ongoing {
        .content {
          margin-bottom: 15px;

          .el-radio-group {
            display: flex;
          }
        }

        .nextAction {
          margin-top: 15px;
        }

        .nextActionRadio {
          margin-bottom: 15px;
          width: 100%;

          label {
            width: 100%;
            margin-bottom: 10px;
          }
        }
      }
    }
  }
</style>

<style lang="scss">
  #sessionAttendance {
    .el-dialog__header {
      padding-top: 25px;
    }

    .notice {
      .el-checkbox {
        display: flex;
        align-items: center;
        white-space: normal;

        .el-checkbox__label {
          font-size: 16px;
          color: #303133;
        }

        &.is-checked {
          .el-checkbox__label {
            color: #409eff;
          }
        }

        .el-checkbox__input {
          line-height: 0;
        }
      }
    }

    .el-dialog__body {
      padding: 20px 20px 0;
    }

    .el-dialog__footer {
      text-align: center;
      padding-top: 20px;
      padding-bottom: 30px;

      .el-button {
        width: 100px;
        padding: 13px 0;
      }
    }

    .el-radio {
      display: flex;
      color: #303133;
      margin-bottom: 10px;

      .el-radio__label {
        word-break: break-word;
        white-space: normal;
        font-size: 16px;
      }
    }
  }
</style>
